<template>
  <div id="app">
    <transition name="overflow-fade">
      <div
        v-if="$root.ready && overflow"
        class="ready-overflow"
        @click="openWebsite()"
      >
        <div class="text-center w-100">
          <div class="title">Undangan {{ title }}</div>
          <span>from</span>
          <div class="mb-5 name">
            {{ wedding.man.surname }} & {{ wedding.woman.surname }}
          </div>

          <button
            class="text-uppercase btn btn-outline-primary"
            @click="openWebsite()"
          >
            Buka Undangan
          </button>
        </div>
      </div>
    </transition>

    <AGWAudio
      ref="audio"
      :file="music.file"
      :loop="music.loop"
      :autoplay="music.autoplay"
    />
    <AGWHero
      overlay
      :background="backgrounds"
      ref="hero"
      parallax
      target="#intro"
    />

    <div
      class="bg-white agw-content"
      :style="{ 'margin-top': `${$root.hero.height}px` }"
    >
      <AGWIntro id="intro" />

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan" />
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes" />
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="pad-y-60" />
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3942.9857971936!2d115.18760947501605!3d-8.7874036912646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwNDcnMTQuNyJTIDExNcKwMTEnMjQuNyJF!5e0!3m2!1sen!2sid!4v1692982695015!5m2!1sen!2sid"
        directionUrl="https://goo.gl/maps/XPedgk598YtyM4b96"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ height: `${$root.dividerHeight}px` }"></div>

    <Footer ref="footer" />

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  "https://ik.imagekit.io/ceremonyku/sunarta-sri/PREWEDDING%20WASKITA%20MANDALA-15.jpg?updatedAt=1692982410272&tr=w-1024";
const ImageHero2 =
  "https://ik.imagekit.io/ceremonyku/sunarta-sri/1%20(7).jpg?updatedAt=1692982406007&tr=w-1024";
const ImageHero3 =
  "https://ik.imagekit.io/ceremonyku/sunarta-sri/PREWEDDING%20WASKITA%20MANDALA-19.jpg?updatedAt=1692982411358&tr=w-1024";

import Audio from "@/assets/audio/soundtrack.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Himbauan from "@/components/Himbauan.vue";
import Attendance from "@/components/Attendance";
import Footer from "@/components/Footer/Remind.vue";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
    Footer
  },
  data() {
    return {
      title: "Pawiwahan",
      backgrounds: [ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      wedding: {
        man: {
          name: " I Wayan Sunarta Amd.Par",
          surname: "Sunarta",
          parents: "I Made Kartana & Ni Wayan Seni",
          description: "Putra pertama",
          address:
            "Perumahan Graha Mandiri, Jl. Kubung Batu III No 9. Taman Griya, Jimbaran",
          photo:
            "https://ik.imagekit.io/ceremonyku/sunarta-sri/PREWEDDING%20WASKITA%20MANDALA-3.jpg?updatedAt=1692982446177&tr=w-400,h-500,fo-custom,cm-extract"
        },
        woman: {
          name: "Ni Made Sri Pratiwi S.Tr.Par",
          surname: "Sri",
          parents: "I Nyoman Sudiarta (Alm) & Ni Nyoman Arsi",
          address: "Jl. Pratama 67a, Gang Ksatria No. 9, Nusa Dua",
          description: "Putri kedua",
          photo:
            "https://ik.imagekit.io/ceremonyku/sunarta-sri/PREWEDDING%20WASKITA%20MANDALA-2.jpg?updatedAt=1692982450949&tr=w-400,h-500,fo-custom,cm-extract"
        }
      },
      location:
        "Perumahan Graha Mandiri, Jl. Kubung Batu III No 9. Taman Griya, Jimbaran",
      time: {
        start: this.$moment("2023-10-20 11:00"),
        end: "Selesai"
      },
      mepandes: [
        {
          name: "Ni Putu Ninda Setiawati"
        },
        {
          name: "I Kadek Wawan Sudiardita"
        },
        {
          name: "I Komang Arya Budi Kusuma"
        },
        {
          name: "I Ketut Nova Wiguna Purta"
        }
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
      this.sw.refreshing = true;
      window.location.reload();
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  }
};
</script>
